// Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
import { memo } from "react";
import { BzButton, BzModal, BzModalBody, BzModalFooter } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { handleModal } from "../../redux/actions/modals";


const RemoveScripStatusModal = () => {
    const modals = useSelector(state => state.modals?.modals);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(handleModal([{ 'REMOVE_SCRIP_STATUS_MODAL': false }]));

    };
    return (
        <Container>
            <BzModal show={modals['REMOVE_SCRIP_STATUS_MODAL']} onHide={handleClose}>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 py-3'>
                            <Col className='text-center'>
                                <div className='icon-64 icon-done icon-positive'></div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-3'>
                            <Col className='text-center font-medium font-size4 color-text'>Scrips removed successfully!</Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={3} className='mrgauto'>
                                <BzButton className='btn btn-block btn-md btn-primary' onClick={handleClose}>OK</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </Container>
    );
};
export default memo(RemoveScripStatusModal);
// Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End
